import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'li3-form-wrapper',
  templateUrl: './form-wrapper.component.html',
  styleUrls: ['./form-wrapper.component.scss']
})
export class FormWrapperComponent implements OnInit {
  @Input() formTitle: string;

  constructor() {
  }

  ngOnInit() {
  }

}
